import { Box, Divider, Flex, Grid, Heading, HStack, Link, Text, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Link as ReactLink, useSearchParams } from 'react-router-dom';
import CampaignCard from '@components/CampaignCard';
import Pagination from '@components/Pagination';
import ContentLayout from '@layouts/ContentLayout';
import { fetchCampaigns } from '@store/actions/referralActions';
import { updateCampaignsReqData } from '@store/actions/reqDataActions';
import useAuthRole from '@hooks/useAuthRole';
import { ROLES } from '@constants';

const Campaigns = () => {
  const dispatch = useDispatch();
  const { hasAuthority } = useAuthRole();
  const hasReferralManagerRole = hasAuthority(ROLES.REFERRAL_MANAGER);
  const [searchParams] = useSearchParams();
  const refresh = JSON.parse(searchParams.get('refresh'));

  const { isLoading, data, totalPages } = useSelector(
    (state) => state.referral.campaign.campaignList
  );

  const reqData = useSelector(
    (state) => state.reqData.referral.campaigns
  );

  const campaignList = data[reqData.pageNo];

  useEffect(() => {
    if (refresh) {
      dispatch(updateCampaignsReqData({ pageNo: 0 }));
      dispatch(fetchCampaigns({ pageNo: 0, pageSize: 10 }, true));
    } else if (!campaignList?.length) {
      dispatch(fetchCampaigns(reqData));
    }
  }, []);

  useEffect(() => {
    if (!campaignList?.length) {
      dispatch(fetchCampaigns(reqData));
    }
  }, [reqData.pageNo]);

  const handlePageChange = (pageNo) => {
    if (pageNo - 1 !== reqData.pageNo) {
      dispatch(updateCampaignsReqData({ pageNo: pageNo - 1 }));
    }
  };

  return (
    <ContentLayout>
      <Grid gridTemplateColumns={{ base: '1fr', lg: '7fr 0fr 2fr' }}>
        <VStack
          p={10}
          gap={4}
          overflowY={{ base: 'initial', lg: 'scroll' }}
          overflowX={'hidden'}
          h={{ lg: '90vh' }}
          px={{ base: 4, sm: 10 }}
          alignItems={'stretch'}
          className="scroll"
        >
          <Flex
            w={'100%'}
            alignItems={'baseline'}
            justifyContent={'space-between'}
            pb={2}
          >
            <Heading color={'colorPrimary'}>Active Campaigns</Heading>
            {hasReferralManagerRole && (
              <Link
                as={ReactLink}
                to="/campaign/create"
                color="brand.500"
                justifyContent={'flex-start'}
              >
                <HStack>
                  <Text>Create new campaign</Text>
                  <BsArrowRight display={'inline'} />
                </HStack>
              </Link>
            )}
          </Flex>

          {totalPages > 0 && (
            <Box alignSelf={'start'}>
              <Pagination
                totalPages={totalPages}
                currentPage={reqData.pageNo + 1}
                onPageChange={handlePageChange}
              />
            </Box>
          )}

          <VStack alignSelf={'flex-start'} maxW={'100%'} gap={1}>
            {isLoading ? (
              <Text color="white">Loading campaigns...</Text>
            ) : campaignList?.length > 0 ? (
              campaignList.map((item) => (
                <CampaignCard key={item.id} campaign={item} />
              ))
            ) : (
              <Text color="white">No campaigns found</Text>
            )}
          </VStack>
        </VStack>
        <Divider
          style={{ margin: '0' }}
          borderColor="whiteAlpha.300"
          orientation="vertical"
        />
      </Grid>
    </ContentLayout>
  );
};

export default Campaigns;
